/* src/app/shared/layout/ag-tree/ag-tree-node/ag-tree-node.component.scss */
.ag-tree-node {
  border-top: 1px solid #c8c7cc;
}
.ag-tree-node .row-container {
  height: 70px;
}
.ag-tree-node.open {
  border-color: #61566e;
  border-width: 2px;
}
.ag-tree-content {
  margin-left: 32px;
}
.agDescription {
  font-size: 13px;
}
.node-toggle {
  min-width: 30px;
  height: 30px;
  border-radius: 15px;
  margin-left: 8px;
}
.node-toggle:hover {
  transition: all 200ms ease-in;
  background-color: rgba(0, 0, 0, 0.1);
}
/*# sourceMappingURL=ag-tree-node.component.css.map */
